import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

export default makeStyles<NextTheme>((theme) =>
  createStyles({
    activeStatusButton: {
      width: 'auto',
      color: '#6E09EA',
      borderColor: '#6E09EA',
    },
    title: {
      fontSize: '1rem',
      lineHeight: '1.6',
      letterSpacing: '0.0075em',
      fontWeight: 'bold',
      color: Colors.dark_gray,
      margin: theme.spacing(3, 0, 1),
    },
    addButton: {
      display: 'flex',
      margin: 0,
    },
    fieldMargin: {
      marginBottom: theme.spacing(3),
    },
    userTimezoneNote: {
      margin: theme.spacing(1, 0),
      color: Colors.gray,
    },
  }),
);
